import { createSlice } from '@reduxjs/toolkit'
import api from "../services/api";
import { checkToken } from "./Usuarios"

const initialPedido = []
const initialPedidoItem = []


const pedidoReduce = createSlice({
    name: 'pedidos',
    initialState: {
      dataPedido: initialPedido,
      dataPedidoItem: initialPedidoItem,
      page: 0,
      hasNext: false,
      loading: false,      
      loadingItem: false   
    },
    reducers: {
      fetchPedido: (state, action) => {
        state.dataPedido = action.payload.pedidos;
        state.hasNext = action.payload.hasNext;
        state.page = action.payload.page;
      },
      fetchPedidoItem: (state, action) => {
        state.dataPedidoItem = action.payload;
      },
      // Reducers para atualizar o loading
      setLoading: (state, action) => {
        state.loading = action.payload;
      },
      setLoadingItem: (state, action) => {
        state.loadingItem = action.payload;
      }
    },
  })

  export default pedidoReduce.reducer


  ///////////////////////////  Actions ///////////////////////////////

// const { fetchPedido, addPedido, editPedido, delPedido } = pedidoReduce.actions
const { fetchPedido, fetchPedidoItem,  setLoading, setLoadingItem } = pedidoReduce.actions

 
export const getPedido = (filial, idVendedor, typeStatus, typeSearch, page) => async dispatch => {
  let params;
  switch(typeSearch.type) {
    case 1:
      params = new URLSearchParams([
        ['filial', filial],
        ['idVendedor', idVendedor],
        ['idPedido', typeSearch.term],
        ['ativo', typeStatus.status],
        ['ultRevisao', 'S'],
        ['limit', 10],
        ['skip', page],
        ['filter', 'SZ1.R_E_C_N_O_ desc']
      ]);
      break;
    case 2:
      params = new URLSearchParams([
        ['filial', filial],
        ['idVendedor', idVendedor],
        ['idCliente', typeSearch.term],
        ['ativo', typeStatus.status],
        ['ultRevisao', 'S'],
        ['limit', 10],
        ['skip', page],
        ['filter', 'SZ1.R_E_C_N_O_ desc']
      ]);
      break;
    case 3:
      params = new URLSearchParams([
        ['filial', filial],
        ['idVendedor', idVendedor],
        ['nmCliente', typeSearch.term],
        ['ativo', typeStatus.status],
        ['ultRevisao', 'S'],
        ['limit', 10],
        ['skip', page],
        ['filter', 'SZ1.R_E_C_N_O_ desc']
      ]);
      break;
    default:
      params = new URLSearchParams([
        ['filial', filial],
        ['idVendedor', idVendedor],
        ['ativo', typeStatus.status],
        ['ultRevisao', 'S'],
        ['limit', 10],
        ['skip', page],
        ['filter', 'SZ1.R_E_C_N_O_ desc']
      ]);
  }
  
  // Inicia o loading antes de chamar a API
  dispatch(setLoading(true));
  
  try {
    const response = await api.get('/pedidos', {
      headers: { Authorization: `Bearer ${checkToken()}` },
      params
    });
    dispatch(fetchPedido(response.data));
  } catch (e) {
    console.error(e.message);
  } finally {
    // Encerra o loading após a requisição (sucesso ou erro)
    dispatch(setLoading(false));
  }
}

export const getPedidoItem = (id) => async dispatch => {
  // Inicia o loading para os itens
  dispatch(setLoadingItem(true));
  
  try {
    const params = new URLSearchParams([
      ['idPedido', id],
      ['limit', 10]
    ]);
    const response = await api.get('/pedidos/itens', {
      headers: { Authorization: `Bearer ${checkToken()}` },
      params
    });
    dispatch(fetchPedidoItem(response.data));
  } catch (e) {
    console.error(e.message);
  } finally {
    // Encerra o loading dos itens após a requisição
    dispatch(setLoadingItem(false));
  }
}

export const postPedido = async (form) => {
  try {
    // const params = new URLSearchParams([['limit', 10]]);
    let response =  await api.post('/pedidos', form, {headers:{Authorization:`Bearer ${checkToken()}`}})
    return response
        // .then((response) => {if(response.status === 200){return cb}})
        // .then((response) => dispatch(addPedido(response.data)))

  }
  catch (e) {
      return console.error(e.message);
  }
}

// export const putPedido = async (form, cb) =>  {
//   try {
//     // const params = new URLSearchParams([['idPedido', form.codPedido]]);
//     await api.put(`/pedidos/${form.codPedido}`, form, {headers:{Authorization:`Bearer ${checkToken()}`}})
//     return cb
//         // .then((response) => dispatch(editPedido(response.data))).then(cb)
//   }
//   catch (e) {
//       return console.error(e.message);
//   }
// }
export const putPedido = (form, cb) => {
  const token = checkToken();
  api
    .put(`/pedidos/${form.codPedido}`, form, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      console.log('Pedido atualizado:', response.data);
      if (response && response.status === 200 && typeof cb === 'function') {
        cb(response.data);
      }
    })
    .catch((error) => {
      console.error('Erro ao atualizar a cotação:', error.response?.data?.message || error.message);
    });
};




// export const deletePedido = (form,cb) => async dispatch => {
//   try {
//     const params = new URLSearchParams([['idPedido ', form.idPedido]]);
//     await api.delete(`/pedidos/${form.idPedido}`, form, params)
//         .then(() => dispatch(delPedido(form))).then(cb)
//   }
//   catch (e) {
//       return console.error(e.message);
//   }
// }